import { render, staticRenderFns } from "./ContactMetricsPercentages.vue?vue&type=template&id=644d386e&"
import script from "./ContactMetricsPercentages.vue?vue&type=script&lang=js&"
export * from "./ContactMetricsPercentages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports